export const support = 'https://wunder-mobility.zendesk.com/hc/en-us';
export const freshdesk = 'https://gourban.freshdesk.com/';
export const rolesAndPremissions = `${freshdesk}support/solutions/articles/48000949358-roles-and-permissions/`;
